import styled from "styled-components";

export const Status = styled.span`
    margin-right:5px;
    color: ${({open}) => open ? '#AAC962' : '#E53E22'};
    font: Bold 13px/18px Roboto;
`;